module.exports = __webpack_public_path__ + "static/media/us_3x4.ae656592.svg";